import { render } from "./ValueFromResource.vue?vue&type=template&id=66f18be8&scoped=true"
import script from "./ValueFromResource.vue?vue&type=script&lang=js"
export * from "./ValueFromResource.vue?vue&type=script&lang=js"

import "./ValueFromResource.vue?vue&type=style&index=0&id=66f18be8&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f18be8"]])

export default __exports__